module.exports = __webpack_public_path__ + "static/media/main.485fb7c6.png";